import { GlobalEnv } from '../global_env'
import { URLQueries } from '../global_env/url_query'
import { getSystemInfo } from '../../../lib/js/util'
import { is, xenv } from '@didi/webx-js'

const getAppId = () => {
  if (is('passenger')) return 10000
  if (is('hypassenger')) return 121449
  if (xenv() === 'hywxmp') return 120054
  if (is('weixin') && GlobalEnv.from === 'xwebapp') return 35009
  return 10000
}

//  重灾区
/**
 * 获取风控参数
 * @param {boolean} isHitButton - 是否是按钮点击
 * @param {boolean} isOpenWeb - 是否打开页面
 */
export const getRiskControlParams = async (
  isHitButton = false,
  isOpenWeb = true
) => {
  const {
    loginInfo,
    locationInfo: { cityId, lat, lng },
    openid,
  } = GlobalEnv
  const env = {
    appid: getAppId(),
    newTicket: loginInfo.token,
    latitude: `${lat || ''}`,
    longitude: `${lng || ''}`,
    userAgent: window.navigator.userAgent,
    cityId: `${cityId || ''}`,
    isHitButton,
    isOpenWeb,
  }
  let systemInfo = {}
  await getSystemInfo().then(res => {
    systemInfo = res
  })
  switch (true) {
    case __mpx_mode__ === 'web' &&
      ['passenger', 'hypassenger'].includes(xenv()):
      Object.assign(env, {
        fromChannel: '1',
        ddfp: String(systemInfo.imei || ''),
        deviceId: String(systemInfo.deviceId || systemInfo.deviceid || ''),
        appVersion: `${URLQueries.getQuery('app_version') || ''}`,
      })
      break
    case __mpx_mode__ === 'web' && is('weixin') && is('miniprogram'):
      Object.assign(env, {
        fromChannel: '2',
      })
      break
    case is('weixin') && is('miniprogram'):
      Object.assign(env, {
        fromChannel: '2',
        openIdType: '1',
      })
      break
    case __mpx_mode__ === 'web' && is('alipay') && is('miniprogram'):
      Object.assign(env, {
        fromChannel: '3',
      })
      break
    case is('alipay') && is('miniprogram'):
      Object.assign(env, {
        fromChannel: '3',
        openIdType: '2',
      })
      break
    case __mpx_mode__ === 'web' && is('mqq'):
      Object.assign(env, {
        fromChannel: '4',
      })
      break
    default:
      Object.assign(env, {
        fromChannel: '8',
      })
  }
  openid &&
    Object.assign(env, {
      openid,
    })
  return env
}
